import(/* webpackMode: "eager" */ "/codebuild/output/src969430339/src/src/app/apps/page.tsx");
